export const FORGOT_PASSWORD_PAGE_TITLE = 'forgot-password-page.title';
export const FORGOT_PASSWORD_PAGE_DESCRIPTION = 'forgot-password-page.description';
export const FORGOT_PASSWORD_PAGE_ICON_ALT = 'forgot-password-page.icon-alt';
